import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { SegmentApi } from "go-segment/services/types";
import { findDocumentActiveSegment } from "./utils";

interface Props {
	segments: SegmentApi[];
	selectedSegment: SegmentApi | undefined;
	setSelectedSegment: (segment: SegmentApi | undefined) => void;
	handleChangeSegment: (segment: SegmentApi | undefined, slug?: string) => void;
}

const DocumentsNavigationSegments = ({ segments, setSelectedSegment, selectedSegment, handleChangeSegment }: Props) => {
	const location = useLocation();
	const [showMore, setShowMore] = useState(false);
	const { t } = useTranslation();
	const INITIAL_SEGMENT_AMOUNT = 5;

	useEffect(() => {
		if (checkIfNewSegmentIsSelected()) {
			setSelectedSegment(findDocumentActiveSegment(segments, location));
		}
	}, [location.search, JSON.stringify(segments)]);

	const checkIfNewSegmentIsSelected = () => {
		return selectedSegment?.slug !== findDocumentActiveSegment(segments, location)?.slug;
	};

	if (segments.length === 0) return <></>;

	return (
		<div className="d-flex flex-column mt-2 px-2 documents-segments">
			{(showMore ? segments : segments.filter((_, index) => index < INITIAL_SEGMENT_AMOUNT)).map((segment) => (
				<div
					onClick={() => handleChangeSegment(segment)}
					className={`documents-segments-item ${
						selectedSegment?.id === segment.id ? "documents-segments-item--active" : ""
					}`}
					key={segment.id}
				>
					{segment.name}
				</div>
			))}
			{segments.length > INITIAL_SEGMENT_AMOUNT && (
				<div
					className="documents-segments-item d-flex show-more-button justify-content-between column-gap-2"
					onClick={() => setShowMore((prevState) => !prevState)}
				>
					<span className="text-primary">
						{showMore ? t("lib:common.action.show_less") : t("lib:common.action.show_more")}
					</span>
					<span className="text-muted">{segments.length - INITIAL_SEGMENT_AMOUNT}</span>
				</div>
			)}
		</div>
	);
};

export default DocumentsNavigationSegments;
